import { Alert, Snackbar } from "@mui/material";

import type { AddCarrierAnnouncement } from "./value_objects";

interface Props {
  announcement: AddCarrierAnnouncement | null;
  onClose: VoidFunction;
}

/**
 * The one way an add-partner outcome is announced, so every placement reports it
 * the same way.
 *
 * Mounted only while there is something to say: a placement can render this once
 * per quote row, and an always-mounted Snackbar costs every row its hook stack.
 * The key restarts the auto-hide timer on a second outcome, which otherwise
 * inherits the first one's remaining time.
 */
export function AddPartnerOutcomeSnackbar(props: Props) {
  const { announcement, onClose } = props;

  if (announcement == null) {
    return null;
  }

  return (
    <Snackbar
      key={announcement.id}
      open
      onClose={onClose}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={announcement.severity}
        variant="filled"
        onClose={onClose}
      >
        {announcement.message}
      </Alert>
    </Snackbar>
  );
}
